import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { FaTrash, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const actionBadgeMap = {
  create: { label: 'Ekleme', className: 'badge-success' },
  update: { label: 'Güncelleme', className: 'badge-primary' },
  delete: { label: 'Silme', className: 'badge-danger' },
  login: { label: 'Giriş', className: 'badge-purple' },
  logout: { label: 'Çıkış', className: 'badge-purple' },
};

export default function AdminActivityLog() {
  useAuth();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ total: 0, totalPages: 1 });

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/activity-log?page=${page}&limit=20`);
      setLogs(Array.isArray(res.data.data) ? res.data.data : []);
      setPagination(res.data.pagination || { total: 0, totalPages: 1 });
    } catch (err) {
      toast.error('Aktivite logları yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClear = async () => {
    if (!window.confirm('30 günden eski log kayıtları silinecek. Emin misiniz?')) return;
    try {
      const res = await api.delete('/activity-log/clear');
      toast.success(res.data.message || 'Eski loglar temizlendi');
      setPage(1);
      fetchLogs();
    } catch (err) {
      toast.error('Temizleme sırasında hata oluştu');
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getActionBadge = (action) => {
    const badge = actionBadgeMap[action] || { label: action, className: 'badge-secondary' };
    return <span className={`badge ${badge.className}`}>{badge.label}</span>;
  };

  if (loading && page === 1) {
    return <div className="admin-loading">Yükleniyor...</div>;
  }

  return (
    <div>
      <div className="admin-card">
        <div className="admin-card-header">
          <h2>Aktivite Logları</h2>
          <button className="btn btn-danger" onClick={handleClear}>
            <FaTrash /> Eski Logları Temizle
          </button>
        </div>

        <table className="admin-table">
          <thead>
            <tr>
              <th>Tarih</th>
              <th>Kullanıcı</th>
              <th>İşlem</th>
              <th>Tür</th>
              <th>Başlık</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center' }}>
                  Henüz log kaydı yok
                </td>
              </tr>
            ) : (
              logs.map((log) => (
                <tr key={log.id}>
                  <td>{formatDate(log.created_at)}</td>
                  <td>{log.username}</td>
                  <td>{getActionBadge(log.action)}</td>
                  <td>{log.entity_type || '-'}</td>
                  <td>{log.entity_title || '-'}</td>
                  <td><code>{log.ip_address || '-'}</code></td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {pagination.totalPages > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', marginTop: '1rem', padding: '1rem 0' }}>
            <button
              className="btn btn-secondary btn-sm"
              disabled={page <= 1}
              onClick={() => setPage((p) => p - 1)}
            >
              <FaChevronLeft /> Önceki
            </button>
            <span>
              Sayfa {page} / {pagination.totalPages} (Toplam: {pagination.total})
            </span>
            <button
              className="btn btn-secondary btn-sm"
              disabled={page >= pagination.totalPages}
              onClick={() => setPage((p) => p + 1)}
            >
              Sonraki <FaChevronRight />
            </button>
          </div>
        )}
      </div>

    </div>
  );
}
